import React from 'react';
import { useNavigate } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { ReactComponent as Logo } from "../../assets/logo.svg";
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import {
  Grid,
  Typography,
  Box,
  Paper,
} from '@material-ui/core';
import { Card, CardContent } from '@mui/material';

const styles = (theme) => ({
  paper: {
    boxShadow: "0px 4px 50px 0px rgba(0, 0, 0, 0.25)"
  },
  container: {
    marginTop: "50px",
    width: "60vw",
    overflow: "auto",
  },
  card: {
    width: "300px",
    flexShrink: 0,
  },
  cardContent: {
    // margin: "16px"
  },
  cardTitle: {
    width: "345px",
    height: "100px",
  },
  cardTitleTypography: {
    color: "#1e3a5f",
    fontFamily: "Georgia, serif",
    fontSize: "26px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "145.385%"
  },
  cardDescription: {
    width: "fit-content",
  },
  cardDescriptionTypography: {
    overflow: "hidden",
    color: "#555",
    textOverflow: "ellipsis",
    whitespace: "nowrap",
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.8"
  },
  arrow:{
    padding: theme.spacing(3),
  }
});

function CaseStudyCards(props) {
  const { classes } = props;
  const navigate = useNavigate();
  const cards = [{
    "cardTitle": "Criminal Case",
    "cardDescription": "We relieve the pressure on internal resources by overseeing the negotiation and delivery of high-volume contracts through efficient contract lifecycle management that reduces complexity and cost.",
    "path":"/criminal-case"
  }, {
    "cardTitle": "Marital Disputes",
    "cardDescription": "We relieve the pressure on internal resources by overseeing the negotiation and delivery of high-volume contracts through efficient contract lifecycle management that reduces complexity and cost.",
    "path":"/marital-disputes"
  }, {
    "cardTitle": "Contract Management",
    "cardDescription": "We relieve the pressure on internal resources by overseeing the negotiation and delivery of high-volume contracts through efficient contract lifecycle management that reduces complexity and cost.",
    "path":"/contract-management"
  }, {
    "cardTitle": "Litigation Support",
    "cardDescription": "We relieve the pressure on internal resources by overseeing the negotiation and delivery of high-volume contracts through efficient contract lifecycle management that reduces complexity and cost.",
    "path":"/litigation-support"
  }, {
    "cardTitle": "Legal Research",
    "cardDescription": "We relieve the pressure on internal resources by overseeing the negotiation and delivery of high-volume contracts through efficient contract lifecycle management that reduces complexity and cost.",
    "path":"/legal-research"
  }]

  return (
    <React.Fragment>
      <Box display="flex" alignItems="center" className={classes.box} spacing={4}>
        <Grid item>
          <Grid container wrap='nowrap' justifyContent="center" spacing={3} className={classes.container}>
            {cards.map((card, index) => {
              return (
                <React.Fragment key={index}>
                  <Grid item>
                    <Paper className={classes.paper} onClick={() => navigate(card.path)}>
                      <Card elevation={0} className={classes.card}>
                        <CardContent className={classes.cardContent}>
                          <Grid container spacing={2}>
                            <Grid item className={classes.cardTitle}>
                              <Typography className={classes.cardTitleTypography}>
                                {card.cardTitle}
                              </Typography>
                            </Grid>
                            <Grid item className={classes.cardDescription}>
                              <Typography className={classes.cardDescriptionTypography}>
                                {card.cardDescription}
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Paper>
                  </Grid>
                </React.Fragment>
              )
            })}
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
}

export default withStyles(styles)(CaseStudyCards);